/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { components, OptionProps, OptionTypeBase } from 'react-select'
import styled from 'styled-components'

// App Components
import Checkbox from '../Checks/Checkbox'

// Type definition
export type CheckOptionProps = {
    setMenuOpen: React.Dispatch<boolean>
} & OptionProps<OptionTypeBase>

const CheckOptionUnstyled: React.FC<CheckOptionProps> = ({
    children,
    isSelected,
    setMenuOpen,
    ...props
}) => (
    <components.Option isSelected={isSelected} {...props}>
        <Checkbox
            checked={isSelected}
            onClick={() => {
                setMenuOpen(true)
            }}
            onChange={() => {
                props.setValue(props.getValue() || [], 'set-value')
            }}
        >
            {children}
        </Checkbox>
    </components.Option>
)

const CheckOption = styled(CheckOptionUnstyled)``

export default CheckOption
